import { useLingui } from '@lingui/react/macro'
import { Badge } from 'designSystem/components/Badge'
import {
  ItemMetaField,
  ItemMetaFieldText,
  ItemMetaRow,
} from 'designSystem/components/Item'
import { ClipboardList, MapPin, Tag } from 'lucide-react'

export function WorkOrderCardMetadata({
  number,
  status,
  assetNumber,
  location,
  updatedAt,
}: {
  number: string
  status: string
  assetNumber?: string | null
  location?: string | null
  updatedAt?: string | null
}) {
  const { t, i18n } = useLingui()
  const updated =
    updatedAt && !Number.isNaN(Date.parse(updatedAt))
      ? i18n.date(new Date(updatedAt), { dateStyle: 'medium', timeZone: 'UTC' })
      : null
  return (
    <ItemMetaRow gap='relaxed'>
      <ItemMetaField>
        <ClipboardList />
        <ItemMetaFieldText>{number}</ItemMetaFieldText>
      </ItemMetaField>
      {status ? (
        <ItemMetaField aria-label={t`Recorded status: ${status}`}>
          <Badge variant='outlineMuted'>{status}</Badge>
        </ItemMetaField>
      ) : null}
      {assetNumber ? (
        <ItemMetaField title={t`Asset`}>
          <Tag />
          <ItemMetaFieldText>{assetNumber}</ItemMetaFieldText>
        </ItemMetaField>
      ) : null}
      {!assetNumber && location ? (
        <ItemMetaField title={t`Location`}>
          <MapPin />
          <ItemMetaFieldText>{location}</ItemMetaFieldText>
        </ItemMetaField>
      ) : null}
      {updated ? (
        <ItemMetaField title={t`Source updated`}>
          <ItemMetaFieldText>{t`Updated ${updated}`}</ItemMetaFieldText>
        </ItemMetaField>
      ) : null}
    </ItemMetaRow>
  )
}
